import React from 'react'
import LoadingBar from "../Images/833.gif";


const Loading = () => {
  return (
      <div className="loadingbar">
          <img src={LoadingBar} alt="" />
          </div>
  )
}

export default Loading